import React, { useCallback } from 'react';
import { PersistentTooltip } from './Tooltip';
import { TooltipIcon } from './icons/TooltipIcon';

export const EXCEEDED_SCRIPT_LIMITS_TOOLIP_ID = 'exceeded-script-limits';

export const ExceededScriptLimitsTooltip = ({
  children,
  position = 'bottom',
  show = true,
  handleDismissTooltip,
  setLocalShowExceedScriptLimitsTooltip,
  style,
}) => {
  const stopPropagation = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  // Add click handler to children to clear dismissal state
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        onClick: (e) => {
          // Preserve original onClick if it exists
          if (child.props.onClick) {
            child.props.onClick(e);
          }
        },
      });
    }
    return child;
  });

  return (
    <>
      <PersistentTooltip
        style={{ ...style }}
        id={EXCEEDED_SCRIPT_LIMITS_TOOLIP_ID}
        className="!w-[500px] !bg-white !p-8 !rounded-xl !z-[1001] !top-[370px] !left-[160px] min-h-fit shadow-[0_4px_20px_rgba(255,255,255,0.2)] border-b-white border-b"
        buttonClassName="!bg-white"
        arrowClassName="!border-b-white"
        content={
          <div
            onClick={stopPropagation}
            onMouseDown={stopPropagation}
            onTouchStart={stopPropagation}
            className="flex flex-col gap-2 text-black"
          >
            <p className="font-roboto flex gap-2 items-center text-lg font-semibold">
              <div className="relative inline-flex items-center">
                <div className="pulse-icon">
                  <TooltipIcon className="relative" />
                </div>
              </div>{' '}
              Exceeded Limit
            </p>
            <div className="h-[0.5px] bg-[#676669] w-full" />
            <div className="flex flex-col font-roboto text-sm">
              <p>Recording Studio limits recording time to 5 minutes.</p>
              <p>Video Script Limit: 4000 characters or 40 segments.</p>
            </div>
          </div>
        }
        position={position}
        show={show}
        onOutsideClick={() => {
          handleDismissTooltip(null, setLocalShowExceedScriptLimitsTooltip);
        }}
        onDismiss={() => {
          handleDismissTooltip(null, setLocalShowExceedScriptLimitsTooltip);
        }}
      >
        {childrenWithProps}
      </PersistentTooltip>
    </>
  );
};
